import Channels from "../base/channels";
import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);
import easesCustom from "../fx/CustomEases";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.items = this.DOM.view.parentElement.querySelectorAll(
      ".FilterView article"
    );
    // console.log(this.DOM.items);
    //!
    this.FX = {};
    this.FX.titleWrapper = new SplitText(this.ref.title[0], {
      type: "lines",
      linesClass: "",
    });
    this.FX.titleContainer = new SplitText(this.ref.title[0], {
      type: "lines",
      linesClass: "tw-overflow-hidden tw-mt-[-5px]",
    });
    gsap.set(this.FX.titleContainer.lines[0], { marginTop: 0 });

    this.funcLaunch = this._fx.bind(this);

    Channels.on("launcher::exit", this.funcLaunch);
    Channels.on("transition::end", this.funcLaunch);
  }

  _fx() {
    this.animate();
  }

  animate() {
    this.animation = gsap.timeline({ delay: 0.1 });

    this.ref.cacheSEO[0].style.display = "none";

    this.animation
      .add([
        gsap.fromTo(
          this.ref.separator,
          {
            transformOrigin: "left top",
            scaleX: 0,
          },
          {
            scaleX: 1,
            ease: "quint.out",
            duration: 1,
            delay: 0.8,
          }
        ),
        gsap.fromTo(
          this.FX.titleWrapper.lines,
          {
            y: 150,
          },
          {
            y: 0,
            ease: easesCustom.cubic,
            duration: 1,
            stagger: 0.1,
          }
        ),
      ])
      .add(
        [
          gsap.fromTo(
            this.ref.date,
            {
              autoAlpha: 0,
              y: 20,
            },
            {
              autoAlpha: 1,
              y: 0,
              ease: "cubic.out",
              duration: 0.6,
            }
          ),
          gsap.fromTo(
            this.DOM.view.querySelector(".fxVisual"),
            {
              autoAlpha: 0,
              scale: 1.2,
            },
            {
              autoAlpha: 1,
              scale: 1.01,
              ease: "quint.out",
              duration: 2,
            }
          ),
        ],
        "-=1"
      );
  }

  unmount() {}
}
